import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  setMapProgress,
  selectMill,
  isPdf,
  inExtent,
  setTimeFilter,
} from "../actions/millActions";
import { setCoordinates, setZoom } from "../actions/settingActions";

import { loadModules, setDefaultOptions, loadCss } from "esri-loader";

import LinearProgress from "@material-ui/core/LinearProgress";

loadCss("4.17");
setDefaultOptions({ version: "4.17" });

export class Map extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
      timeSliderExpanded: false,
    };
  }

  view;
  layer;
  grenzeLayer;
  myMap;
  zoom;
  timeSlider;
  highlight;
  lastResult = { attributes: { Name: null } };

  filterMillsByExtent = () => {
    this.layer.when(() => {
      var queryParams = this.layer.createQuery();
      queryParams.geometry = this.view.extent;
      if (this.state.timeSliderExpanded) {
        queryParams.timeExtent = this.timeSlider.timeExtent;
      }
      queryParams.where = "";
      if (this.props.municipality.length > 0) {
        var filterStatement = "(";
        this.props.municipality.forEach((element) => {
          filterStatement += `OR Gemeinde='${element}'`;
        });
        filterStatement = filterStatement.replace("OR ", "");
        queryParams.where = filterStatement + ")";
      }
      if (this.props.propulsion.length > 0) {
        // eslint-disable-next-line
        var filterStatement = "";
        this.props.propulsion.forEach((element) => {
          filterStatement += `OR Antriebsart='${element}'`;
        });
        filterStatement = filterStatement.replace("OR ", "");
        if (queryParams.where !== "") {
          queryParams.where =
            queryParams.where + " AND (" + filterStatement + ")";
        } else {
          queryParams.where = "(" + filterStatement + ")";
        }
      }
      if (this.props.exists.length > 0) {
        // eslint-disable-next-line
        var filterStatement = "";
        this.props.exists.forEach((element) => {
          filterStatement += `OR GebäudeVorhanden='${element}'`;
        });
        filterStatement = filterStatement.replace("OR ", "");
        if (queryParams.where !== "") {
          queryParams.where =
            queryParams.where + " AND (" + filterStatement + ")";
        } else {
          queryParams.where = "(" + filterStatement + ")";
        }
      }
      this.layer.queryFeatures(queryParams).then((response) => {
        this.props.inExtent(
          response.features.map((feature) => {
            return feature.attributes.Objektnr;
          })
        );
      });
    });
  };

  selectAndZoomToMill = (view, layer, query, goTo) => {
    view.whenLayerView(layer).then((layerView) => {
      var effect = {
        filter: {},
        excludedEffect: "",
      };
      this.highlight && this.highlight.remove();
      if (query) {
        effect.filter.where = query; //`Objektnr='${nr}'`;
        effect.excludedEffect = "grayscale(50%) opacity(60%)";
        var queryParams = this.layer.createQuery();
        queryParams.outSpatialReference = view.spatialReference;
        queryParams.where = query;
        layerView.queryFeatures(queryParams).then((response) => {
          this.highlight = layerView.highlight(response.features);
          this.lastResult = response.features;
          if (goTo && response.features && response.features[0]) {
            view.goTo(response.features[0].geometry);
          }
        });
      }
      layerView.effect = effect;
    });
  };

  zoomToLayer = (view, layer, query) => {
    var queryParams = layer.createQuery();
    queryParams.outSpatialReference = view.spatialReference;
    if (query) {
      queryParams.where = query;
    }
    layer.queryExtent(queryParams).then((response) => {
      view.goTo(response.extent);
    });
  };

  componentDidMount() {
    loadModules([
      "esri/config",
      "esri/Map",
      "esri/Basemap",
      "esri/views/MapView",
      "esri/layers/FeatureLayer",
      "esri/core/watchUtils",
      "esri/widgets/Expand",
      "esri/widgets/Legend",
      "esri/widgets/BasemapGallery",
      "esri/widgets/Locate",
      "esri/widgets/TimeSlider",
      "esri/layers/TileLayer",
      "esri/layers/VectorTileLayer",
      "esri/layers/WMTSLayer",
    ]).then(
      ([
        esriConfig,
        Map,
        Basemap,
        MapView,
        FeatureLayer,
        watchUtils,
        Expand,
        Legend,
        BasemapGallery,
        Locate,
        TimeSlider,
        TileLayer,
        VectorTileLayer,
        WMTSLayer,
      ]) => {
        // https://community.esri.com/t5/arcgis-api-for-javascript/properly-change-the-format-of-queries/td-p/181646
        esriConfig.request.interceptors.push({
          urls: /FeatureServer\/\d+$/,
          after: function (response) {
            response.data.supportedQueryFormats = "JSON";
          },
        });

        var stadtplanLayer = new TileLayer({
          url: "https://geoportal.kreis-herford.de/arcgis/rest/services/WWW/Stadtplan/MapServer",
        });

        var greyVectorLayer = new VectorTileLayer({
          url: "https://www.arcgis.com/sharing/rest/content/items/8a2cba3b0ebf4140b7c0dc5ee149549a/resources/styles/root.json",
        });

        var liegenschaftskarteLayer = new TileLayer({
          url: "https://geoportal.kreis-herford.de/arcgis/rest/services/WWW/Liegenschaftskarte/MapServer",
        });

        var luftbildWeltweit = new TileLayer({
          url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer",
        });
        var luftbildNrw = new WMTSLayer({
          url: "https://www.wmts.nrw.de/geobasis/wmts_nw_dop",
        });

        // create a basemap from a dynamic mapserver
        const stadtplan = new Basemap({
          baseLayers: [greyVectorLayer, stadtplanLayer],
          title: "Stadtplan",
          id: "stadtplan",
          thumbnailUrl:
            "https://geoportal.kreis-herford.de/gis/sharing/rest/content/items/6173f85cc3c34bb29d65648be4d1a080/info/thumbnail/thumbnail1562835617619.png",
        });

        const luftbild = new Basemap({
          baseLayers: [luftbildWeltweit, luftbildNrw],
          title: "Luftbild",
          id: "luftbild",
          thumbnailUrl:
            "https://geoportal.kreis-herford.de/gis/sharing/rest/content/items/ae662faa64c541d7a5f6dc0dde9f6f5d/info/thumbnail/thumbnail1562834234915.png?token=yVxbhSIqsXrzH9j0c3gLb6Wc2T3rvynpGtuW1AeVx9cyoj1JZYxhAcIz6dGaU0H5qsCoZxQPpSG873daUuBMrCdrkBCxH6_GegqOy9SwpkteBktID8GsAdOMqtoUJQ0aQtLNnhhCAfXqGazDRwTxx4YCHRECp12k3zvWyAtfgm3J2jpVvBtq7Lt1hvKfbqj815JbuL8Fr1jrqT4_MKUdzfrir53rkureqgnxg3IBzgg.",
        });

        const liegenschaftskarte = new Basemap({
          baseLayers: [greyVectorLayer, liegenschaftskarteLayer],
          title: "Liegenschaftskarte",
          id: "liegenschaftskarte",
          thumbnailUrl:
            "https://geoportal.kreis-herford.de/gis/sharing/rest/content/items/6d35e9072ff841118f76e50c55c3c46d/info/thumbnail/thumbnail1562836613340.png?token=yVxbhSIqsXrzH9j0c3gLb6Wc2T3rvynpGtuW1AeVx9cyoj1JZYxhAcIz6dGaU0H5qsCoZxQPpSG873daUuBMrCdrkBCxH6_GegqOy9SwpkteBktID8GsAdOMqtoUJQ0aQtLNnhhCAfXqGazDRwTxx4YCHRECp12k3zvWyAtfgm3J2jpVvBtq7Lt1hvKfbqj815JbuL8Fr1jrqT4_MKUdzfrir53rkureqgnxg3IBzgg.",
        });

        var myMap = new Map({
          basemap: stadtplan,
        });

        this.layer = new FeatureLayer({
          url: "https://geoportal.kreis-herford.de/gis/rest/services/KR/Muehlen/FeatureServer/0",
          outFields: [
            "Name",
            "Objektnr",
            "Antriebsart",
            "Gemeinde",
            "GebäudeVorhanden",
            "Thumb",
            "PDF",
            "HTML",
            "Bilder",
          ],
          //visible: false,
        });

        this.grenzeLayer = new FeatureLayer({
          url: "https://geoportal.kreis-herford.de/gis/rest/services/Kataster/Gebietsgrenzen/MapServer/0",
          //visible: false
        });

        myMap.addMany([this.grenzeLayer, this.layer]);

        // Create a MapView instance (for 2D viewing) and reference the map instance
        this.view = new MapView({
          container: this.mapRef.current,
          map: myMap,
          highlightOptions: {
            color: [255, 0, 0],
            fillOpacity: 0,
          },
        });

        // #################################################################################
        // Widgets
        // #################################################################################

        // legend
        const legend = new Expand({
          expandIconClass: "esri-icon-legend",
          expandTooltip: "Legende anzeigen",
          content: new Legend({
            view: this.view,
            style: "classic",
          }),
          view: this.view,
          expanded: false,
        });
        this.view.ui.add(legend, "top-right");

        // basemap
        var basemapGallery = new BasemapGallery({
          view: this.view,
          map: this.myMap,
          source: [
            stadtplan,
            luftbild,
            liegenschaftskarte,
            Basemap.fromId("osm"),
          ],
        });

        var expandBasemap = new Expand({
          expandIconClass: "esri-icon-basemap",
          expandTooltip: "Hintergrundkarte wählen",
          content: basemapGallery,
        });

        this.view.ui.add(expandBasemap, "bottom-left");

        // locate
        var locateBtn = new Locate({
          view: this.view,
        });

        this.view.ui.add(locateBtn, "top-left");

        // timeSlider
        this.timeSlider = new TimeSlider({
          view: this.view,
          container: "timeSliderDiv",
          mode: "cumulative-from-start",
          disabled: true,
          fullTimeExtent: {
            // entire extent of the timeSlider
            start: new Date(1200, 0, 1),
            end: new Date(2000, 0, 1),
          },
          values: [
            // location of timeSlider thumbs
            new Date(2000, 0, 1),
          ],
          tickConfigs: [
            {
              mode: "position",
              values: [
                new Date(1200, 0, 1),
                new Date(1400, 0, 1),
                new Date(1600, 0, 1),
                new Date(1800, 0, 1),
                new Date(2000, 0, 1),
              ].map((date) => date.getTime()),
              labelsVisible: true,
              labelFormatFunction: (value) => {
                const date = new Date(value);
                return `${date.getFullYear()}`;
              },
              tickCreatedFunction: (value, tickElement, labelElement) => {
                tickElement.classList.add("custom-ticks");
                labelElement.classList.add("custom-labels");
              },
            },
          ],
          labelFormatFunction: (value, type, element, layout) => {
            switch (type) {
              case "min":
              case "max":
                element.innerText = value.getFullYear();
                break;
              case "extent":
                const start = this.timeSlider.fullTimeExtent.start;
                var text;
                if (value[0].getFullYear() === start.getFullYear()) {
                  text = start.getFullYear();
                } else {
                  text = `von ${start.getFullYear()} bis ${value[0].getFullYear()}`;
                }
                if (this.state.timeSliderExpanded) {
                  this.props.setTimeFilter(text);
                }
                element.innerText = text;
                break;
              default:
                element.innerText = "";
            }
          },
        });

        var expandTimeSlider = new Expand({
          expandIconClass: "esri-icon-time-clock",
          expandTooltip: "zeitlichen Filter einstellen",
          content: this.timeSlider.container,
        });

        expandTimeSlider.watch("expanded", (expanded) => {
          if (expanded) {
            this.timeSlider.values = [new Date(1200, 0, 1)];
            this.timeSlider.play();
            this.setState({ timeSliderExpanded: true });
          } else {
            this.timeSlider.values = [new Date(2000, 0, 1)];
            this.props.setTimeFilter();
            this.setState({ timeSliderExpanded: false });
          }
        });

        this.view.ui.add(expandTimeSlider, "bottom-left");

        // wait until the layer view is loaded
        let timeLayerView;
        this.view.whenLayerView(this.layer).then((layerView) => {
          timeLayerView = layerView;
          this.timeSlider.disabled = false;
          // const fullTimeExtent = layer.timeInfo.fullTimeExtent;
          // const start = fullTimeExtent.start;
          // set up time slider properties based on layer timeInfo
          this.timeSlider.stops = {
            interval: {
              value: 10,
              unit: "years",
            },
          };
        });

        // #################################################################################
        // Zoom to layer
        // #################################################################################
        this.view.goTo({
          center: [8.598821, 52.175902],
          zoom: 10,
        });

        this.grenzeLayer.when(() => {
          var filter = {};
          if (this.props.municipality.length > 0) {
            var filterStatement = "";
            this.props.municipality.forEach((element) => {
              filterStatement += `OR gemeinde='${element}'`;
            });
            filterStatement = filterStatement
              .replace("OR ", "")
              .replace(new RegExp("oe", "g"), "ö")
              .replace("ue", "ü");
            filter.where = filterStatement;
          }
          this.view.whenLayerView(this.grenzeLayer).then((layerView) => {
            layerView.filter = filter;
            this.zoomToLayer(this.view, this.grenzeLayer, filter.where);
          });
        });

        // #################################################################################
        // Mills
        // #################################################################################
        this.layer &&
          this.layer.when(() => {
            this.view.whenLayerView(this.layer).then((layerView) => {
              var filter = {};
              if (this.props.municipality.length > 0) {
                var filterStatement = "";
                this.props.municipality.forEach((element) => {
                  filterStatement += `OR Gemeinde='${element}'`;
                });
                filterStatement = filterStatement.replace("OR ", "");
                filter.where = "(" + filterStatement + ")";
              }
              if (this.props.propulsion.length > 0) {
                // eslint-disable-next-line
                var filterStatement = "";
                this.props.propulsion.forEach((element) => {
                  filterStatement += `OR Antriebsart='${element}'`;
                });
                filterStatement = filterStatement.replace("OR ", "");
                if (filter.where) {
                  filter.where =
                    filter.where + " AND (" + filterStatement + ")";
                } else {
                  filter.where = "(" + filterStatement + ")";
                }
              }
              if (this.props.exists.length > 0) {
                // eslint-disable-next-line
                var filterStatement = "";
                this.props.exists.forEach((element) => {
                  filterStatement += `OR GebäudeVorhanden='${element}'`;
                });
                filterStatement = filterStatement.replace("OR ", "");
                if (filter.where) {
                  filter.where =
                    filter.where + " AND (" + filterStatement + ")";
                } else {
                  filter.where = "(" + filterStatement + ")";
                }
              }
              layerView.filter = filter;
              this.filterMillsByExtent();
              this.props.setMapProgress();

              // highlight selected mill
              if (this.props.selected.Objektnr) {
                setTimeout(() => {
                  this.selectAndZoomToMill(
                    this.view,
                    this.layer,
                    `Objektnr='${this.props.selected.Objektnr}'`,
                    true
                  );
                }, 0);
              }

              // Get the screen point from the view's click event
              this.view.on("click", (event) => {
                var screenPoint = {
                  x: event.x,
                  y: event.y,
                };
                // Search for graphics at the clicked location
                this.view.hitTest(screenPoint).then((response) => {
                  if (response.results.length) {
                    var graphic = response.results.filter((result) => {
                      // check if the graphic belongs to the layer of interest
                      return result.graphic.layer === this.layer;
                    });
                    if (graphic[0]) {
                      graphic = graphic[0].graphic;
                      this.props.selectMill(graphic.attributes, "map");
                      //this.highlight && this.highlight.remove();
                      //layerView.highlight(graphic);
                      //this.lastResult = graphic;
                      // do something with the result graphic
                    } else {
                      this.props.selectMill();
                    }
                  } else {
                    this.props.selectMill();
                  }
                });
              });
            });
          });

        // #################################################################################
        // detect mills in extent
        // #################################################################################
        var beginNavigation;
        watchUtils.when(this.view, "interacting", () => {
          beginNavigation = this.view.get("navigating");
        });

        watchUtils.when(this.view, "stationary", () => {
          const currentnavigation = this.view.get("navigating");
          if (!currentnavigation && currentnavigation !== beginNavigation) {
            if (this.view.extent) {
              this.filterMillsByExtent();
              this.props.setZoom(this.view.zoom);
              this.props.setCoordinates(
                this.view.center.longitude,
                this.view.center.latitude
              );
            }
          }
        });

        this.timeSlider.watch("timeExtent", (value) => {
          // update layer view filter to reflect current timeExtent
          var filter = {
            timeExtent: value,
          };
          if (this.props.municipality.length > 0) {
            var filterStatement = "(";
            this.props.municipality.forEach((element) => {
              filterStatement += `OR Gemeinde='${element}'`;
            });
            filterStatement = filterStatement.replace("OR ", "");
            filter.where = filterStatement + ")";
          }
          if (this.props.propulsion.length > 0) {
            // eslint-disable-next-line
            var filterStatement = "";
            this.props.propulsion.forEach((element) => {
              filterStatement += `OR Antriebsart='${element}'`;
            });
            filterStatement = filterStatement.replace("OR ", "");
            if (filter.where) {
              filter.where = filter.where + " AND (" + filterStatement + ")";
            } else {
              filter.where = "(" + filterStatement + ")";
            }
          }
          if (this.props.exists.length > 0) {
            // eslint-disable-next-line
            var filterStatement = "";
            this.props.exists.forEach((element) => {
              filterStatement += `OR GebäudeVorhanden='${element}'`;
            });
            filterStatement = filterStatement.replace("OR ", "");
            if (filter.where) {
              filter.where = filter.where + " AND (" + filterStatement + ")";
            } else {
              filter.where = "(" + filterStatement + ")";
            }
          }
          timeLayerView.filter = filter;
          this.filterMillsByExtent();
        });
      }
    );
  }

  componentDidUpdate(prevProps) {
    // nach Gemeinde filtern, sobald die Gemeinde-Auswahl verändert wurde.
    if (
      prevProps.municipality !== this.props.municipality ||
      prevProps.propulsion !== this.props.propulsion ||
      prevProps.exists !== this.props.exists
    ) {
      this.layer &&
        this.layer.when(() => {
          this.view.popup.close();
          var filter = {};
          var grenzeFilter = {};
          if (this.props.municipality.length > 0) {
            var filterStatement = "(";
            var filterStatementGrenze = "";
            this.props.municipality.forEach((element) => {
              filterStatement += `OR Gemeinde='${element}'`;
              filterStatementGrenze += `OR gemeinde='${element}'`;
            });
            filterStatement = filterStatement.replace("OR ", "");
            filterStatementGrenze = filterStatementGrenze
              .replace("OR ", "")
              .replace(new RegExp("oe", "g"), "ö")
              .replace("ue", "ü");
            // https://developers.arcgis.com/javascript/latest/sample-code/sandbox/index.html?sample=featurefilter-attributes
            filter.where = filterStatement + ")";
            grenzeFilter.where = filterStatementGrenze;
          }
          if (this.props.propulsion.length > 0) {
            // eslint-disable-next-line
            var filterStatement = "(";
            if (filter.where) {
              filterStatement = " AND (";
            }
            this.props.propulsion.forEach((element) => {
              filterStatement += `OR Antriebsart='${element}'`;
            });
            filterStatement = filterStatement.replace("OR ", "");
            if (filter.where) {
              filter.where = filter.where + filterStatement + ")";
            } else {
              filter.where = filterStatement + ")";
            }
          }
          if (this.props.exists.length > 0) {
            // eslint-disable-next-line
            var filterStatement = "(";
            if (filter.where) {
              filterStatement = " AND (";
            }
            this.props.exists.forEach((element) => {
              filterStatement += `OR GebäudeVorhanden='${element}'`;
            });
            filterStatement = filterStatement.replace("OR ", "");
            if (filter.where) {
              filter.where = filter.where + filterStatement + ")";
            } else {
              filter.where = filterStatement + ")";
            }
          }
          this.filterMillsByExtent();
          this.zoomToLayer(this.view, this.grenzeLayer, grenzeFilter.where);
          this.view.whenLayerView(this.layer).then((layerView) => {
            layerView.filter = filter;
          });
          this.view.whenLayerView(this.grenzeLayer).then((layerView) => {
            layerView.filter = grenzeFilter;
          });
        });
    }

    if (prevProps.selected !== this.props.selected) {
      this.layer &&
        this.layer.when(() => {
          if (this.props.selected.Objektnr) {
            if (this.props.selected.art === "image") {
              this.selectAndZoomToMill(
                this.view,
                this.layer,
                `Objektnr='${this.props.selected.Objektnr}'`,
                true
              );
            } else {
              this.selectAndZoomToMill(
                this.view,
                this.layer,
                `Objektnr='${this.props.selected.Objektnr}'`,
                false
              );
            }
          } else {
            this.selectAndZoomToMill(this.view, this.layer);
          }
        });
    }
  }

  render() {
    return (
      <div>
        {this.props.progress ? (
          <div style={{ justifyContent: "center", display: "flex" }}>
            <div
              className="progress_"
              style={{
                height: "calc((100vH - 66px - 260px) / 2)",
                minHeight: "calc(350px / 2)",
                margin: "0 20px",
                maxWidth: "400px",
                width: "calc(100% - 40px)",
                alignContent: "center",
                display: "grid",
              }}
            >
              <LinearProgress color="primary" />
              <p style={{ marginTop: "20px", textAlign: "center" }}>
                Karteninhalte werden geladen.
              </p>
            </div>
          </div>
        ) : null}
        <div
          className="webmap"
          ref={this.mapRef}
          style={{
            visibility: this.props.progress ? "hidden" : "visible",
            minHeight: "350px",
            height: "calc(100vH - 66px - 262px)",
            margin: "0 0px",
          }}
        ></div>
        <div
          id="timeSliderDiv"
          style={this.props.progress ? { height: "0px" } : {}}
        ></div>
      </div>
    );
  }
}

Map.propTypes = {
  mills: PropTypes.object.isRequired,
  municipality: PropTypes.array.isRequired,
  propulsion: PropTypes.array.isRequired,
  exists: PropTypes.array.isRequired,
  selectMill: PropTypes.func.isRequired,
  isPdf: PropTypes.func.isRequired,
  inExtent: PropTypes.func.isRequired,
  setMapProgress: PropTypes.func.isRequired,
  selected: PropTypes.object.isRequired,
  progress: PropTypes.bool.isRequired,
  setCoordinates: PropTypes.func.isRequired,
  setZoom: PropTypes.func.isRequired,
  setTimeFilter: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  mills: state.mill.mills,
  selected: state.mill.selected,
  municipality: state.mill.filter.municipality,
  propulsion: state.mill.filter.propulsion,
  exists: state.mill.filter.exists,
  progress: state.mill.progressMap,
});

export default connect(mapStateToProps, {
  setMapProgress,
  selectMill,
  isPdf,
  inExtent,
  setCoordinates,
  setZoom,
  setTimeFilter,
})(Map);
